'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _domUtil = require('../../utils/domUtil');

var _EditableTitle = require('../../components/editableTitle/EditableTitle');

var _EditableTitle2 = _interopRequireDefault(_EditableTitle);

require('./LinkMetadata.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkMetadata = function LinkMetadata(props) {
    var element = props.element,
        isEditable = props.isEditable,
        isSingleSelected = props.isSingleSelected,
        isSelected = props.isSelected;

    var linkData = element.getIn(['content', 'link']);

    if (!linkData) return null;

    var linkWrapper = _react2.default.createElement('a', { href: linkData.get('url'), target: '_blank', onClick: _domUtil.stopPropagationOnly });

    return _react2.default.createElement(
        'div',
        { className: 'LinkMetadata' },
        _react2.default.createElement(_EditableTitle2.default, {
            element: element,
            elementId: element.get('id'),
            isEditable: isEditable,
            initialValue: linkData.get('title'),
            maxLength: 500,
            isSelected: isSelected,
            wrapTitleElement: !isSingleSelected ? linkWrapper : null,
            editorKey: 'LINK_TITLE' })
    );
};

LinkMetadata.propTypes = {
    element: _propTypes2.default.object.isRequired,
    isEditable: _propTypes2.default.bool,
    isSelected: _propTypes2.default.bool,
    isSingleSelected: _propTypes2.default.bool
};

exports.default = LinkMetadata;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/link/LinkMetadata.js
// module id = 2001
// module chunks = 0